import React, { forwardRef } from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import { Editor } from '@tinymce/tinymce-react';
import clsx from 'clsx';
import { When } from 'UI/components/atoms';

import { useResetEditorToolbar } from './FPTextEditor.hooks';
import { useStyles } from './styles';

const tinyApiKey = process.env.REACT_APP_TINYMCE_API_KEY;

const FPTextEditor = forwardRef(
  ({
    colorVariant,
    config,
    containerClassName,
    disabled,
    error,
    errorText,
    helperText,
    onChange,
    onFocus,
    onInit,
    value
  }) => {
    const color = disabled ? colorVariant : 'normal';
    const classes = useStyles({ error, color });
    useResetEditorToolbar();

    const handleEditorChange = editorValue => onChange && onChange(editorValue);

    const formHelperText = helperText || (error && errorText);

    return (
      <FormControl error={error} className={clsx(classes.editorContainer, containerClassName)}>
        <When condition={!!formHelperText}>
          <FormHelperText className={classes.errorText}>{formHelperText}</FormHelperText>
        </When>
        <Editor
          onInit={onInit}
          init={config}
          apiKey={tinyApiKey}
          disabled={disabled}
          value={value}
          onFocus={onFocus}
          onEditorChange={handleEditorChange}
        />
      </FormControl>
    );
  }
);

FPTextEditor.defaultProps = {
  value: undefined,
  error: false,
  errorText: '',
  disabled: false,
  colorVariant: 'opaque',
  onChange: undefined,
  onFocus: () => {}
};

export default FPTextEditor;
